import { all, takeLatest, select, put, race, take, call } from 'redux-saga/effects';
import { Orders } from '@grandvisionhq/api-client';
import { Selectors, State, Actions, getToken } from '@grandvisionhq/auth';
import { ApiConfigSelectors } from '@grandvisionhq/state';
import { CREATE_ORDER, createOrderFailed, createOrderSuccess } from './actions.js';
import prescriptionsSagas from './Prescriptions/state/sagas.js';
import profileSagas from './Profile/sagas.js';
import subscriptionsSagas from './Subscriptions/sagas.js';
import unlinkOrderSagas from './Unlink/sagas.js';

function* onCreateOrder(action) {
    let auth = yield select(Selectors.getAuth);
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    if (!apiConfig) {
        throw new Error('Need API configuration to create order.');
    }
    // Firstly, we might need to recover the session
    if (State.isInitialized(auth)) {
        yield put(Actions.LoginActions.recoverSession());
        const { loggedIn  } = yield race({
            loggedIn: take(Actions.LoginActions.PARSE_HASH_SUCCEEDED),
            loginFailed: take(Actions.LoginActions.RECOVER_SESSION_FAILED)
        });
        if (loggedIn) {
            auth = yield select(Selectors.getAuth);
        }
    }
    if (!State.isLoggedIn(auth)) {
        yield put(createOrderFailed(new Error(`Can only create order on behalf of user when they're actually logged-in`)));
        return;
    }
    try {
        const token = yield call(getToken);
        const result = yield call(Orders.createForCustomer, apiConfig.ordersUrl, auth.userId, token, action.payload);
        yield put(createOrderSuccess(result));
    } catch (err) {
        yield put(createOrderFailed(err));
    }
}
function* sagas() {
    yield all([
        ...subscriptionsSagas,
        ...prescriptionsSagas,
        ...profileSagas,
        ...unlinkOrderSagas,
        takeLatest(CREATE_ORDER, onCreateOrder), 
    ]);
}

export { sagas as default, onCreateOrder };
//# sourceMappingURL=sagas.js.map
